module.exports = __webpack_public_path__ + "static/side-img-2-8c705054553cc5e08a6bc3cb31a7eac4.png";